import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { IApiResult } from '../../interface/IApiResult';
import { apiGetPayMemmoryConfirm } from '../../service/apiGetPayMemmoryConfirm';
import { SngPayDto } from '../../dto/SngPayDto';

export const ConfirmCloudPay = () => {
  const { lendingId, appId } = useParams();

  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [sngPayDto, setSngPayDto] = useState<SngPayDto>({
    pid: '',
    price: 0,
  });

  const getPurchaseDescr = (route: string) => {
    if (route === 'com.learnanat.fullaccess') {
      return 'Анатомия на месяц';
    }
    if (route === 'com.learnmed.histology.fullaccess') {
      return 'Гистология на месяц';
    }
    if (route === 'com.learnmed.biochemistry.fullaccess') {
      return 'Биохимия на месяц';
    }
    if (route === 'com.learnmed.physiology.fullaccess') {
      return 'Физиология на месяц';
    }
    if (route === 'com.learnanat.fullaccess.year') {
      return 'Анатомия на год';
    }
    if (route === 'com.learnmed.histology.fullaccess.year') {
      return 'Гистология на год';
    }
    if (route === 'com.learnmed.biochemistry.fullaccess.year') {
      return 'Биохимия на год';
    }
    if (route === 'com.learnmed.physiology.fullaccess.year') {
      return 'Физиология на год';
    }
    return '';
  };

  const getPayDto = async () => {
    let preadmetDescrString = '';
    const { pid } = sngPayDto;
    const priceToPay = sngPayDto.price;

    if (priceToPay === 0) {
      return;
    }

    const predmetArray = pid.split(';');
    for (let i = 0; i < predmetArray.length; i += 1) {
      preadmetDescrString = `${preadmetDescrString}${getPurchaseDescr(
        predmetArray[i]
      )}, `;
    }

    if (pid === '' || appId === '' || priceToPay === 0) {
      return;
    }

    preadmetDescrString = preadmetDescrString.substring(
      0,
      preadmetDescrString.length - 2
    );
    setIsProcessing(true);
    setError(null);

    // Проверяем, загружен ли CloudPayments
    if (!window.cp) {
      setError(
        'Платёжная система не загружена. Проверьте подключение к интернету.'
      );
      setIsProcessing(false);
      return;
    }
    try {
      const payments = new window.cp.CloudPayments({
        language: 'ru-RU',
        email: '',
        applePaySupport: true,
        googlePaySupport: true,
        yandexPaySupport: false,
        tinkoffPaySupport: false,
        tinkoffInstallmentSupport: false,
        sbpSupport: false,
      });

      payments
        .pay('charge', {
          publicId: 'pk_7a84a9d5cf0ed73ddc4b58179120e',
          description: preadmetDescrString,
          amount: priceToPay,
          currency: 'RUB',
          invoiceId: `${lendingId}-${appId}`,
          accountId: appId || '',
          email: '',
          skin: 'modern',
          requireEmail: true,
          data: {
            referrerId: pid,
          },
        })
        .then((result: any) => {
          console.log('Оплата успешна:', result);
          setIsProcessing(false);
          // Можно показать уведомление об успехе
        })
        .catch((err: { message: any }) => {
          console.error('Ошибка оплаты:', err);
          setError(err.message || 'Ошибка при оплате');
          setIsProcessing(false);
        });
    } catch (err) {
      setError('Ошибка инициализации платежа');
      setIsProcessing(false);
    }
  };

  const autoUrl = async () => {
    const apiResult: IApiResult = await apiGetPayMemmoryConfirm(
      lendingId ?? ''
    );
    if (apiResult.isSuccess) {
      setSngPayDto(apiResult.data);
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments.js';
    script.async = true;

    // Добавляем обработчик загрузки
    script.onload = () => {
      console.log('CloudPayments widget loaded');
      // Если виджет требует ручной инициализации, сделайте это здесь
      // Например: window.cloudpayments?.init();
      if (lendingId !== undefined && appId !== undefined) {
        autoUrl();
      }
    };

    script.onerror = () => {
      console.error('Failed to load CloudPayments widget');
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (
      lendingId !== undefined &&
      appId !== undefined &&
      sngPayDto.pid !== ''
    ) {
      getPayDto();
    }
  }, [sngPayDto]);

  return <div> </div>;
};
